module.exports = __webpack_public_path__ + "img/983802170.0ec879ea.jpg";